import { Injectable, signal, computed } from '@angular/core';
import { Session } from '../../services/Session';

@Injectable({ providedIn: 'root' })
export class OnboardingStore {

  private get _maxInvites(): number {
    const plan: string = (Session.getUser() as any)?.subscriptionPlan
      || (Session.get('signupData') as any)?.plan
      || '';
    if (plan.toLowerCase().includes('growth'))   return 4;
    if (plan.toLowerCase().includes('standard')) return 1;
    return 0; // Basic — no invites
  }

  readonly maxInvites  = signal(0);
  readonly STEP_LABELS = signal<string[]>(['Book your Meeting', 'Invite Additional User']);

  readonly currentStep  = signal(0);
  readonly currentLabel = computed(() => this.STEP_LABELS()[this.currentStep()] ?? 'success');
  readonly isComplete   = computed(() => this.currentStep() >= this.STEP_LABELS().length);

  nextStep() { this.currentStep.update(s => s + 1); }
  prevStep() { this.currentStep.update(s => Math.max(0, s - 1)); }

  jumpTo(label: string) {
    const idx = this.STEP_LABELS().indexOf(label);
    if (idx !== -1) this.currentStep.set(idx);
  }

  reset() {
    const max = this._maxInvites;
    this.maxInvites.set(max);
    const labels = ['Book your Meeting'];
    if (max > 0) labels.push('Invite Additional User');
    this.STEP_LABELS.set(labels);
    this.currentStep.set(0);
  }
}
